export const albumFilterType = Object.freeze({
  ALL: 'all',
  MY_ALBUMS: 'myAlbums',
});
